export const PREFIX = 'CooCaa'
export const IS_POWERED_BY_PLUGIN = !!window.__MICRO_APP_ENVIRONMENT__
export const API_PREFIX_MAP = {
  dev: 'https://dev-api.cloud.coocaa.com',
  beta: 'https://beta-api.cloud.coocaa.com',
  pro: 'https://api.cloud.coocaa.com'
}
